import styled from '@emotion/styled';
import {Drawer, List} from '@mui/material';

export const LeftNavDrawerStyle = styled(Drawer)`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ListStyle = styled(List)`
  flex: 1;
  height: inherit;
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
`;